var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7662 20C11.9889 20 11.5088 19.152 11.9087 18.4855L16.1425 11.4292C16.5309 10.7818 17.4691 10.7818 17.8575 11.4292L22.0913 18.4855C22.4912 19.152 22.0111 20 21.2338 20H12.7662Z",
    fill: "#FEEFD7",
    stroke: "#976821",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76619 20C1.9889 20 1.50878 19.152 1.9087 18.4855L9.14251 6.42916C9.53091 5.78182 10.4691 5.78182 10.8575 6.42915L18.0913 18.4855C18.4912 19.152 18.0111 20 17.2338 20H2.76619Z",
    fill: "#FEEFD7",
    stroke: "#976821",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 6,
    r: 2,
    fill: "#FEEFD7",
    stroke: "#976821",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.77825359.svg";
export { ForwardRef as ReactComponent };